import { render } from "./DeprecatedDashboardView.vue?vue&type=template&id=655e2ded&scoped=true&ts=true"
import script from "./DeprecatedDashboardView.vue?vue&type=script&lang=ts"
export * from "./DeprecatedDashboardView.vue?vue&type=script&lang=ts"

import "./DeprecatedDashboardView.vue?vue&type=style&index=0&id=655e2ded&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655e2ded"]])

export default __exports__